"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Input_1 = require("./components/Input");
var Textarea_1 = require("./components/Textarea");
var hocs_1 = require("./hocs");
/**
 * Checks whether a component is an Input.
 * @param Component - React Component constructor.
 * @returns {boolean} - Whether the component is an Input.
 */
function isInput(Component) {
    return Component.displayName === Input_1.displayName;
}
/**
 * Checks whether a component is a Textarea.
 * @param Component - React Component constructor.
 * @returns {boolean} - Whether the component is a Textarea.
 */
function isTextarea(Component) {
    return Component.displayName === Textarea_1.displayName;
}
/**
 * Curries through HoCs from left-to-right to generate composed component.
 * @param Component - React component.
 * @param hocs - Higher Order Components.
 * @returns Composed component.
 */
function composeHocs(Component, hocs) {
    return hocs.reduce(function (EnhancedComponent, composableFn) {
        return composableFn(EnhancedComponent);
    }, Component);
}
/**
 * Composes a new component based from common configuration.
 * @param Component - React component.
 * @param config - Configuration of component.
 * @returns Composed component.
 */
function composeCommon(Component, _a) {
    var description = _a.description, icons = _a.icons, label = _a.label, loading = _a.loading;
    var commonHocs = [];
    // withLoading needs the component to be icon compatible.
    if (loading) {
        commonHocs.push(hocs_1.withIcons, hocs_1.withLoading);
    }
    else if (icons) {
        commonHocs.push(hocs_1.withIcons);
    }
    if (description) {
        commonHocs.push(hocs_1.withDescription);
    }
    if (label) {
        commonHocs.push(hocs_1.withLabel);
    }
    return composeHocs(Component, commonHocs);
}
/**
 * Composes a new component based from input configuration.
 * @param Component - React component.
 * @param config - Configuration of component.
 * @returns Composed component.
 */
function composeInput(Component, _a) {
    var enterKey = _a.enterKey;
    var inputHocs = [];
    if (enterKey) {
        inputHocs.push(hocs_1.withEnterKey);
    }
    return composeHocs(Component, inputHocs);
}
/**
 * Composes a new component based from textarea configuration.
 * @param Component - React component.
 * @param config - Configuration of component.
 * @returns Composed component.
 */
function composeTextarea(Component, _a) {
    var autogrow = _a.autogrow;
    var textareaHocs = [];
    if (autogrow) {
        textareaHocs.push(hocs_1.withAutogrow);
    }
    return composeHocs(Component, textareaHocs);
}
/**
 * Composes a new component. Composition of component depends on order.
 * We make modification to DOM first then add functionality later.
 * @param config - Configuration of enhanced component.
 * @returns Final composed component.
 */
exports.compose = function (config) { return function (Component) {
    var NewComponent;
    NewComponent = composeCommon(Component, config);
    if (isInput(Component)) {
        NewComponent = composeInput(NewComponent, config);
    }
    else if (isTextarea(Component)) {
        NewComponent = composeTextarea(NewComponent, config);
    }
    return hocs_1.withParentClass(NewComponent);
}; };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/utils.js
// module id = 182
// module chunks = 0 1